import React from 'react';
import Icon from '../ui/AppIcon';
import PWAInstallButton from '../pwa/PWAInstallButton';

const STEPS = [
  {
    n: '1',
    title: 'Open in Safari',
    body: 'On iPhone, open https://patelsalesonline.com in Safari (not Chrome or Instagram).',
  },
  {
    n: '2',
    title: 'Tap Share',
    body: 'Tap the Share button at the bottom (square with an arrow pointing up).',
  },
  {
    n: '3',
    title: 'Add to Home Screen',
    body: 'Scroll and tap “Add to Home Screen”, then tap Add. Patel Sales appears on your Home Screen.',
  },
];

/** Static iPhone instructions on Get the App page for wholesale clients */
export default function IOSInstallSteps() {
  return (
    <section className="bg-[#f0f4fa] py-12 sm:py-14 border-y border-[#003087]/10">
      <div className="max-w-3xl mx-auto px-3 sm:px-4 md:px-6">
        <div className="text-center mb-8">
          <p className="text-[#e8471e] text-xs font-bold tracking-wide uppercase mb-2">
            For iPhone clients
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            Install Patel Sales on iPhone
          </h2>
          <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
            Apple does not allow a one-tap download. Use these 3 steps — takes under a minute.
          </p>
        </div>

        <div className="space-y-4 mb-8">
          {STEPS.map((step) => (
            <div
              key={step.n}
              className="flex gap-4 bg-white rounded-2xl border border-gray-200 p-4 sm:p-5 shadow-sm"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#003087] text-white font-bold">
                {step.n}
              </span>
              <div>
                <h3 className="font-bold text-gray-900 mb-1">{step.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{step.body}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <PWAInstallButton label="Show install steps" />
          <p className="text-xs text-gray-500 flex items-center gap-1.5">
            <Icon name="DevicePhoneMobileIcon" size={14} />
            On iPhone, Install opens these steps automatically
          </p>
        </div>
      </div>
    </section>
  );
}
